import React from 'react';

const More = () => {
    return (
        <section className='container mt-5 mb-5'>
            <h2 className='text-center text-uppercase fw-bold'>About Me</h2>

            <div className='col'>
                <h3 className="fw-bold">
                    Hi! I'm Rakibul Islam. I'm a <strong className="text-color">MERN STACK</strong> Web
                    Developer.
                </h3>
                <h5> I am an enthusiastic Web Developer, having expertise in web application development, javascript problem solving, server-side development, and mobile app development. But highly interested in Client-Side web development.
                    <br /><br />

                    The creation of this portfolio provided me with a chance to reflect on both my technical skills and my professional skills for several years. As you browse around, I hope that you are able to gain a strong sense of me. Each section of this portfolio represents a small piece of information that reflects who I am and what I am capable of.</h5>
            </div>
        </section>
    );
};

export default More;